import { render, staticRenderFns } from "./ImageCarouselSwiper.vue?vue&type=template&id=e46b3138&"
import script from "./ImageCarouselSwiper.vue?vue&type=script&lang=js&"
export * from "./ImageCarouselSwiper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports